import { cn as e } from "../cn.js";
import "react";
import { cva as t } from "class-variance-authority";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
// src/design/typography/index.tsx
var i = t("", {
	variants: {
		level: {
			h1: "text-h1 leading-tight tracking-tight",
			h2: "text-2xl leading-tight tracking-tight",
			h3: "text-xl leading-snug",
			h4: "text-lg leading-snug",
			h5: "text-base leading-normal",
			h6: "text-sm leading-normal"
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold",
			bold: "font-bold"
		},
		color: {
			foreground: "text-foreground",
			muted: "text-muted-foreground",
			primary: "text-primary",
			success: "text-success-text",
			warning: "text-warning-text",
			danger: "text-destructive-text"
		}
	},
	defaultVariants: {
		level: "h2",
		weight: "semibold",
		color: "foreground"
	}
});
function a({ level: t, weight: r, color: a, as: o, className: s, children: c, ...l }) {
	return /* @__PURE__ */ n(o || t || "h2", {
		className: e(i({
			level: t,
			weight: r,
			color: a
		}), s),
		...l,
		children: c
	});
}
var o = t("text-xl leading-7 font-semibold text-foreground"), s = t("text-sm leading-6 text-muted-foreground");
function c({ className: t, children: r, ...i }) {
	return /* @__PURE__ */ n("h1", {
		className: e(o(), t),
		...i,
		children: r
	});
}
function l({ className: t, children: r, ...i }) {
	return /* @__PURE__ */ n("p", {
		className: e(s(), t),
		...i,
		children: r
	});
}
var u = t("", {
	variants: {
		variant: {
			body: "text-sm leading-relaxed",
			small: "text-xs leading-normal",
			caption: "text-xs leading-normal",
			overline: "text-xs font-medium leading-normal"
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold",
			bold: "font-bold"
		},
		color: {
			foreground: "text-foreground",
			muted: "text-muted-foreground",
			primary: "text-primary",
			success: "text-success-text",
			warning: "text-warning-text",
			danger: "text-destructive-text"
		},
		muted: {
			true: "text-muted-foreground",
			false: ""
		},
		numeric: {
			true: "tabular-nums",
			false: ""
		}
	},
	defaultVariants: {
		variant: "body",
		weight: "normal",
		color: "foreground",
		muted: !1,
		numeric: !1
	}
});
function d({ variant: t, weight: r, muted: i, numeric: a, color: o, as: s = "p", className: c, children: l, ...d }) {
	return /* @__PURE__ */ n(s, {
		className: e(u({
			variant: t,
			weight: r,
			muted: i,
			numeric: a,
			color: i ? void 0 : o
		}), c),
		...d,
		children: l
	});
}
var f = t("font-mono", {
	variants: { inline: {
		true: "px-1.5 py-0.5 rounded-md bg-muted text-foreground text-sm border border-border",
		false: "block p-4 rounded-lg overflow-x-auto bg-card border border-border text-card-foreground"
	} },
	defaultVariants: { inline: !0 }
});
function p({ inline: t = !0, className: r, children: i, ...a }) {
	return t ? /* @__PURE__ */ n("code", {
		className: e(f({ inline: !0 }), r),
		...a,
		children: i
	}) : /* @__PURE__ */ n("pre", {
		className: e(f({ inline: !1 }), r),
		...a,
		children: /* @__PURE__ */ n("code", {
			className: "text-sm font-mono text-card-foreground",
			children: i
		})
	});
}
var m = t("pl-4 border-l-4 border-border text-muted-foreground italic");
function h({ cite: t, className: n, children: i, ...a }) {
	return /* @__PURE__ */ r("blockquote", {
		className: e(m(), n),
		...a,
		children: [i, t && /* @__PURE__ */ r("footer", {
			className: "mt-2 text-sm text-muted-foreground not-italic",
			children: ["— ", t]
		})]
	});
}
var g = t("space-y-2 text-foreground list-inside", {
	variants: { ordered: {
		true: "list-decimal",
		false: "list-disc"
	} },
	defaultVariants: { ordered: !1 }
});
function _({ ordered: t, className: r, children: i, ...a }) {
	return /* @__PURE__ */ n(t ? "ol" : "ul", {
		className: e(g({ ordered: t }), r),
		...a,
		children: i
	});
}
var v = t("text-primary hover:text-primary/80 transition-colors", {
	variants: { underline: {
		true: "underline underline-offset-2",
		false: ""
	} },
	defaultVariants: { underline: !0 }
});
function y({ href: t, external: i = !1, underline: a, className: o, children: s, ...c }) {
	return /* @__PURE__ */ r("a", {
		href: t,
		target: i ? "_blank" : void 0,
		rel: i ? "noopener noreferrer" : void 0,
		className: e(v({ underline: a }), o),
		...c,
		children: [s, i && /* @__PURE__ */ n("span", {
			className: "ml-1 inline-block",
			children: "↗"
		})]
	});
}
var b = t("block text-sm font-medium text-foreground mb-1");
function x({ htmlFor: t, required: i = !1, className: a, children: o, ...s }) {
	return /* @__PURE__ */ r("label", {
		htmlFor: t,
		className: e(b(), a),
		...s,
		children: [o, i && /* @__PURE__ */ n("span", {
			className: "text-destructive ml-1",
			children: "*"
		})]
	});
}
var S = t("font-bold leading-none tracking-tighter", {
	variants: {
		size: {
			sm: "text-4xl md:text-5xl lg:text-6xl",
			md: "text-5xl md:text-6xl lg:text-7xl",
			lg: "text-6xl md:text-7xl lg:text-8xl"
		},
		gradient: {
			true: "bg-gradient-to-r from-foreground to-muted-foreground bg-clip-text text-transparent",
			false: "text-foreground"
		}
	},
	defaultVariants: {
		size: "md",
		gradient: !1
	}
});
function C({ size: t, gradient: r, className: i, children: a, ...o }) {
	return /* @__PURE__ */ n("h1", {
		className: e(S({
			size: t,
			gradient: r
		}), i),
		...o,
		children: a
	});
}
var w = {
	Heading: a,
	Text: d,
	Code: p,
	Blockquote: h,
	List: _,
	Link: y,
	Label: x,
	Display: C,
	PageHeading: c,
	SubHeading: l
};
export { w as Typography };

//# sourceMappingURL=index.js.map